import React from 'react';
import { statusPalette } from '@guryou/colors';
import PropTypes from 'prop-types';

// The one rounded pill-style toggle track, shared by every context that needs a
// compact on/off control (list rows, Performance Hub inline toggles, settings
// panels) — replaces three previously-independent implementations (Performance
// Hub's studioPrimitives.Toggle, gymAccess/GymAccessConfig's local Toggle, and
// raw MUI Switch/SwitchBox on list pages). Always stops click propagation itself
// so it's safe to use inside a clickable table row without every call site
// having to remember to call event.stopPropagation().
// Defaults are the real active/critical status colors (green/red) — active,
// published, enabled always reads green; off always reads red. No neutral gray
// default: every on/off toggle in this app is a status, not a plain UI switch.
const ToggleSwitch = ({
  checked,
  onChange,
  disabled,
  primary = statusPalette.active,
  border = statusPalette.critical,
  style
}) => /*#__PURE__*/React.createElement("div", {
  role: "switch",
  "aria-checked": checked,
  onClick: e => {
    e.stopPropagation();
    if (!disabled) {
      onChange(!checked);
    }
  },
  style: {
    width: 36,
    height: 20,
    borderRadius: 999,
    backgroundColor: checked ? primary : border,
    position: 'relative',
    transition: 'background-color 0.2s',
    flexShrink: 0,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    ...style
  }
}, /*#__PURE__*/React.createElement("div", {
  style: {
    position: 'absolute',
    top: 2,
    left: checked ? 17 : 2,
    width: 16,
    height: 16,
    borderRadius: '50%',
    backgroundColor: '#fff',
    boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
    transition: 'left 0.2s'
  }
}));
ToggleSwitch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  primary: PropTypes.string,
  border: PropTypes.string,
  style: PropTypes.object
};
export default ToggleSwitch;